// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3QjfJ","OrderButton":"BuildControls_OrderButton__2QyvR","enable":"BuildControls_enable__2qzPG"};